<template>
  <HeadUp :toHome="toHome"></HeadUp>
  <div class="intro">
    <div class="step-title">注册香港 Apple ID</div>
    <div class="step-number">1</div>
    <div>
      打开 <a href="https://appleid.apple.com" target="_blank">appleid.apple.com</a> <br>选择【创建您的Apple ID】<br>
      <div class="img">
        <img class="step-screenshot" src="@/assets/images/iosSetting/1.1.jpg">
        <span class="block-span"></span>
        <img class="step-screenshot" src="@/assets/images/iosSetting/1.2.jpg">
      </div>
    </div>
    <div class="step-number">2</div>
    <div>
      您需要准备：<br>
      邮箱：从未注册 Apple ID 的真实邮箱<br>
      手机号：中国大陆手机号<br>
      <div class="img">
        <img class="step-screenshot" src="@/assets/images/iosSetting/2.jpg">
      </div>
    </div>
    <div class="step-number">3</div>
    <div>
      验证您的邮箱和手机号<br>
      <div class="img">
        <img class="step-screenshot" src="@/assets/images/iosSetting/3.1.jpg">
        <span class="block-span"></span>
        <img class="step-screenshot" src="@/assets/images/iosSetting/3.2.jpg">
      </div>
    </div>
    <div class="step-number">4</div>
    <div class="img">
      当进入该页面
      <br>
      您的香港 Apple ID 已注册成功<br>
      <img class="step-screenshot" src="@/assets/images/iosSetting/4.jpg">
    </div>
    <div class="step-number">5</div>
    <div class="img">
      打开 App Store，点右上角头像<br>
      滑到屏幕底部，退出登录 <br>
      <img class="step-screenshot" src="@/assets/images/iosSetting/5.1.jpg">
      <span class="block-span"></span>
      <img class="step-screenshot" src="@/assets/images/iosSetting/5.2.jpg">
    </div>
    <div class="step-number">6</div>
    <div class="img">
      滑到屏幕顶部，用新建的香港 Apple ID 登录
      <br>
      在弹窗中点【检查】<br>
      <img class="step-screenshot" src="@/assets/images/iosSetting/6.1.jpg">
      <span class="block-span"></span>
      <img class="step-screenshot" src="@/assets/images/iosSetting/6.2.jpg">
    </div>
    <div class="step-number">7</div>
    <div class="img">
      同意条款，随意填写街道和电话，点【下一页】<br>
      <img class="step-screenshot" src="@/assets/images/iosSetting/7.1.jpg">
      <span class="block-span"></span>
      <img class="step-screenshot" src="@/assets/images/iosSetting/7.2.jpg">
    </div>
    <div class="step-number">8</div>
    <div>
      至此，您的香港 Apple ID 已可用<br>
      如无法使用，请尝试
      <a :href="`guide_pub_setting.html?from=${from}`">公用 AppleID</a><br>
      <br>
      立即 <a @click="downloadInstall()" :href="iosUrl">安装狗急加速</a> <br>
      <br>
      <div class="app-store-like">
        <a @click="downloadInstall()" :href="iosUrl">
          <span>
            <img class="app-icon" src="@/assets/images/icon_app.png"/>
          </span>
          <span>
            <ul>
              <li class="app-title">狗急加速</li>
              <li class="app-intro">将跳转至 AppStore</li>
              <li class="app-get">安装</li>
            </ul>
          </span>
        </a>
      </div>
      <br><br>
    </div>
  </div>
  <div class="flex-item"></div>
  <Footer></Footer>
</template>

<script>
  import { useStore } from "vuex"

  import HeadUp from '../components/Head.vue'
  import Footer from '../components/Footer.vue'

  import utils from '../utils/utils'
  import { ref } from "vue"
  import {getDomain} from "@/config";

  export default {
    name: 'GuideHarmonyOS',
    components: {
      Footer,
      HeadUp
    },
    setup () {
      let store = useStore().state
      function setTitle (lang) {
        document.title = store.languages[lang]['title']
      }

      function getTitle () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/lpt-title`)
          .then(data => {
            const _data = data.data.obj
            Object.keys(_data).forEach(k => {
              store.languages[k]['title'] = _data[k]
            })
            setTitle(store.lang)
          })
          .catch(err => {
            console.log(err)
          })
      }

      let iosUrl = ref('https://apps.apple.com/app/id1559485550')
      function getDownloadUrl () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/ios-url`)
          .then(data => {
            const _data = data.data.obj
            iosUrl.vlaue = _data['ios-appstore-url']
          })
          .catch(err => {
            console.log(err)
          })
      }

      let from = utils.getQuery('from') || 'index'
      function toHome(){
        window.location.href = `${from}.html`
      }

      function downloadInstall () {
        utils.statsDownload("ios")
      }

      let address =  [
          {
            name: "美国地址", address: "www.meiguodizhi.com"
          },
          {
            name: "香港地址", address: "www.meiguodizhi.com/hk-address"
          },
          {
            name: "马来西亚", address: "www.meiguodizhi.com/my-address"
          }
      ]

      function copy (value) {
        utils.copy(value)
      }

      return {
        copy,
        address,
        from,
        store,
        getTitle,
        setTitle,
        iosUrl,
        getDownloadUrl,
        toHome,
        downloadInstall
      }
    },
    created () {
      this.getTitle()
      let lang = utils.getCookie('lang')
      useStore().commit('change', (lang || 'zh'))
      this.setTitle(this.store.lang)
      let html = document.getElementsByTagName('html')[0]
      utils.bindBGCEvent(html, 'white', '#000000')
      this.getDownloadUrl()
      utils.creatCutomerService()
    }
  }
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  body, html {
    font-size: 12px;
  }
  body {
    font-family: Roboto,sans-serif;
    font-weight: 700;
    height: 100%;
    z-index: -1;
    width: 100%;
  }
  ul {
    list-style: none;
  }
  #app{
    width: 100%;
  }
  .intro {
    background-color: white;/* Todo: Try to remove this since unreasonable */
    padding: 6rem 0 2rem 0;
    font-size: 1.2rem;
    text-align: center;
  }

  .intro span {
    display: inline-block;
    vertical-align: middle;
  }

  .intro ul {
    text-align: center;
  }

  .intro a:hover,
  .intro a:link,
  .intro a:visited,
  .intro a:active {
    color: #0066FF;
    text-decoration: underline;
  }

  .intro .step-title {
    background-color: #CC1424;
    color: white;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 0.25rem;
    font-size: 1.5rem;
    border: 3px solid #4D2C22;
    border-radius: 10rem;
    box-shadow: 0 4px 0 0 #00000030;
    -webkit-box-shadow: 0 4px 0 0 #00000030;
    -moz-box-shadow: 0 4px 0 0 #00000030;
  }

  .intro .step-box {
    display: block;
    background-color: #EEEEEE;
    color: black;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 1.5rem;
    font-size: 1.2rem;
    border: 3px solid #4D4D4D;
    border-radius: 2rem;
    box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -webkit-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -moz-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
  }

  .intro .step-box hr {
    margin: 1.5rem;
    border: 0;
    border-top: 2px dotted lightgrey;
  }

  .intro .step-number {
    background-color: black;
    color: white;
    border-radius: 10rem;
    border: none;
    margin: auto auto 1.2rem auto;
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
    font-size: 1.2rem;
    text-align: center;
  }

  .intro .step-comment {
    font-size: 1rem;
    color: darkgrey;
  }

  .intro .img {
    /*display: flex;*/
    /*width: 100%;*/
    /*justify-content: space-between;*/
    padding: 0 2.5%;
  }
  .intro .img .block-span{
    width: 20px;
    display: inline-block
  }
  .intro .step-screenshot {
    width: 40%;
    max-width: 200px;
    border-radius: 15px;
    border: 1px dotted lightgrey;
    margin: 1rem auto 3rem auto;
  }

  .intro .app-store-like .app-icon {
    height: 6rem;
    margin-right: .5rem;
    border-radius: 1.4rem;
    display: block;
  }

  .intro .app-store-like ul {
    text-align: left;
  }

  .intro .app-store-like .app-title {
    color: black;
    font-size: 1.5rem;
  }

  .intro .app-store-like .app-intro {
    color: #999999;
    margin-bottom: 0.2rem;
    font-size: 1rem;
  }

  .intro .app-store-like .app-get, .intro .step-button, .intro a.step-button {
    background-color: #0066FF;
    border-radius: 20rem;
    border: none;
    color: white;
    padding: 0.2rem 1.2rem;
    display: inline-block;
    font-size: 1.2rem;
    cursor: pointer;
    text-decoration: none;
  }

  .intro .app-store-like .app-get.unpaid {
    background-color: #b2b2b2;
  }

  .intro .pub-app-id-acc-flex-wrapper {
    width: 100%;
    max-width: 600px;
    margin: auto;
    text-align: left;
    /*line-height: 3rem;*/
    border: 0;
    border-top: 1px dotted lightgrey;
    display: flex;
  }

  .intro .pub-app-id-acc, .intro .pub-app-id-psw {
    flex: 1;
  }

  .intro .pub-app-id-acc-cp, .intro .pub-app-id-psw-cp {
    color: #0066FF;
    /*text-decoration: underline;*/
  }
  .address {
    margin: auto;
    text-align: start;
    display: grid;
    grid-template-columns: max-content max-content;
    row-gap: 1rem;
    justify-content: center;
  }
  .address span{
    white-space: nowrap;
  }
  .address > * {
    /*width: 100%;*/
    /*max-width: 600px;*/
    /*margin: auto;*/
    /*text-align: left;*/
    /*line-height: 3rem;*/
    border: 0;
    border-bottom: 1px dotted lightgrey;
    padding-bottom: 1rem;
    /*display: flex;*/
  }
  @media all and  (max-width: 765px) {
    .intro .step-screenshot {
      width: 40%;
    }
    .intro .img .block-span{
      width: 20px;
      display: inline-block
    }
  }
</style>
